/* eslint-disable react/no-unescaped-entities */
import { Reveal } from "@/components/site/Reveal";
import { PROBLEM_STATS } from "@/lib/content";

export default function Problem() {
  return (
    <section className="relative py-24 md:py-32 bg-white overflow-hidden">
      <div className="w-full max-w-[1400px] mx-auto px-5 md:px-10">
        <div className="grid lg:grid-cols-12 gap-10 lg:gap-16 items-end">
          <div className="lg:col-span-6">
            <Reveal>
              <p className="text-xs uppercase tracking-[0.25em] text-navy-900/60 font-semibold mb-4">The problem</p>
              <h2 className="font-display text-4xl md:text-6xl font-semibold tracking-tight leading-[1.02] text-navy-900">
                Every missed call is a
                <span className="text-textlight"> customer calling your competitor.</span>
              </h2>
            </Reveal>
          </div>
          <div className="lg:col-span-6">
            <Reveal delay={0.1}>
              <p className="text-lg text-textgray leading-relaxed">
                You're on a job, a technician is in the field, the office is already handling another call, or
                it's after hours. Meanwhile, a homeowner is calling because their AC just stopped working.
                The person who should answer the phone isn't always available to answer the phone.
                <span className="text-navy-900 font-medium"> But your AI Dispatcher can.</span>
              </p>
              <p className="mt-4 font-display text-lg font-semibold text-navy-900">
                Missed calls = missed HVAC jobs.
              </p>
            </Reveal>
          </div>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-px mt-16 rounded-md overflow-hidden border border-graymid bg-graymid">
          {PROBLEM_STATS.map((s, i) => (
            <Reveal key={i} delay={i * 0.1} className="bg-graylight">
              <div className="p-8 md:p-10 h-full">
                <div className="font-display text-5xl md:text-6xl font-bold text-navy-900 tracking-tight">{s.value}</div>
                <p className="mt-3 text-textgray leading-relaxed">{s.label}</p>
              </div>
            </Reveal>
          ))}
        </div>

        <Reveal delay={0.15} className="flex justify-center">
          <p className="mt-16 font-serif-editorial italic text-2xl md:text-4xl text-navy-900/70 max-w-3xl text-center">
            "HVAC companies miss <span className="text-navy-900 not-italic font-display font-semibold">30% or more of incoming calls</span> during summer/winter peak seasons, when call volume spikes. That's booked jobs, revenue, and profit — ringing out."
          </p>
        </Reveal>
      </div>
    </section>
  );
}
